import { Capacitor } from '@capacitor/core';
import { getPreference, removePreference, setPreference } from '@store/prefrences';

export const useHandleCache = () => {
	const isWeb = Capacitor.getPlatform() === 'web';

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const setCache = async (key: string, value: any) => {
		const stringValue = typeof value === 'string' ? value : JSON.stringify(value);
		if (isWeb) {
			await localStorage.setItem(key, stringValue);
		} else {
			await setPreference({
				key,
				value: stringValue,
			});
		}
	};

	const getCache = async (key: string) => {
		const rawValue = isWeb ? localStorage.getItem(key) : await getPreference(key);

		if (typeof rawValue !== 'string') return null;

		if ((rawValue.startsWith('{') && rawValue.endsWith('}')) || (rawValue.startsWith('[') && rawValue.endsWith(']'))) {
			try {
				const parsed = JSON.parse(rawValue);
				return parsed;
			} catch {
				return rawValue;
			}
		} else {
			return rawValue;
		}
	};

	const clearCache = async (key: string) => {
		if (isWeb) {
			localStorage.removeItem(key);
		} else {
			await removePreference(key);
		}
	};

	return { setCache, getCache, clearCache };
};
